import React from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import styles from './ContentOwnership.module.scss'

export const ContentOwnership = (props) => {
	const sharedByExists = Boolean(props.sharedBy && Object.keys(props.sharedBy).length)
	return (
		sharedByExists ? (
			<div className={styles.container}>
				<div className={styles.user}>{props.sharedBy.avatar ? <img className={styles.avatar} src={props.sharedBy.avatar} /> : <i className={styles.icon}>{props.sharedBy.firstName.charAt(0)}</i>}</div>
				<div className={styles.details}>
					<p className={styles.username}>
						From {props.sharedBy.firstName} {props.sharedBy.lastName}
					</p>
					<p className={styles.description}>Shared {props.type}s cannot be edited.</p>
				</div>
			</div>
		) : (
			<div className={styles.container}>
				<div className={styles.user}>{<i className={styles.icon}/>}</div>
				<p className={styles.description}>Shared {props.type}s cannot be edited.</p>
			</div>
		)
	)
}

ContentOwnership.propTypes = {
	sharedBy: PropTypes.object,
	type: PropTypes.string,
}

export default connect((model) => ({}))(ContentOwnership)
